import { format, formatDistanceToNowStrict, isValid, parseISO } from 'date-fns';

export const formatEntryTime = (iso: string, now: Date = new Date()): string => {
  const date = parseISO(iso);
  if (!isValid(date)) return '';
  if (now.getTime() - date.getTime() < 60_000) return 'just now';
  return formatDistanceToNowStrict(date, { addSuffix: true });
};

export const formatEntryTimestamp = (iso: string): string => {
  const date = parseISO(iso);
  return isValid(date) ? format(date, 'MMM d, yyyy, HH:mm') : '';
};
